<clr-datagrid>
  <clr-dg-column>Наименование</clr-dg-column>
  <clr-dg-column>Склад</clr-dg-column>
  <clr-dg-column>Забележка</clr-dg-column>
  <clr-dg-column>ReleaseDate</clr-dg-column>
  <clr-dg-column>ExpiryDate</clr-dg-column>
  <clr-dg-column>Стандартна себестойност</clr-dg-column>

  <clr-dg-row *clrDgItems="let res of result; let i = index" [clrDgItem]="recipie">
    <clr-dg-cell>{{res.recipe.Name}}</clr-dg-cell>
    <clr-dg-cell>{{res.recipe.Store?.Name?.BG}}</clr-dg-cell>
    <clr-dg-cell>{{res.recipe.Note}}</clr-dg-cell>
    <clr-dg-cell>{{res.recipe.ReleaseDate | date}}</clr-dg-cell>
    <clr-dg-cell>{{res.recipe.ExpiryDate | date}}</clr-dg-cell>
    <clr-dg-cell>{{res.recipe?.Product?.StandardCostPerLot?.Value}} {{res.recipe?.Product?.StandardCostPerLot?.Currency}}</clr-dg-cell>

    <ng-container ngProjectAs="clr-dg-row-detail">
      <clr-dg-row-detail *clrIfExpanded="true">
        <clr-datagrid style="width: 100%;">

          <clr-dg-placeholder>Няма съставки в тази технология</clr-dg-placeholder>

          <clr-dg-column>Ред</clr-dg-column>
          <clr-dg-column>Материал</clr-dg-column>
          <clr-dg-column>Стандартна себестойност</clr-dg-column>
          <clr-dg-column>Количество</clr-dg-column>
          <clr-dg-column>Замени с Материал</clr-dg-column>
          <clr-dg-column>Стандартна себестойност</clr-dg-column>
          <clr-dg-column>Количество</clr-dg-column>
          <clr-dg-column>Обща себестойност</clr-dg-column>

          <clr-dg-row [style.background-color]="ingredient.rowColor" *ngFor="let ingredient of res.ingredients">
            <clr-dg-cell>{{ingredient?.ingredient?.LineOrd}}</clr-dg-cell>
            <clr-dg-cell>{{ingredient?.ingredient?.Material?.Name?.BG}}</clr-dg-cell>
            <clr-dg-cell>{{ingredient?.ingredient?.Material?.StandardCostPerLot?.Value}}
              {{ingredient?.ingredient?.Material?.StandardCostPerLot?.Currency}}</clr-dg-cell>
            <clr-dg-cell>{{ingredient?.ingredient?.UsageQuantity?.Value}}
              {{ingredient?.ingredient?.UsageQuantity?.Unit}}</clr-dg-cell>

            <clr-dg-cell>{{ingredient?.replace?.productName}}</clr-dg-cell>
            <clr-dg-cell>{{ingredient?.replace?.product?.StandardCostPerLot?.Value}}
              {{ingredient?.replace?.product?.StandardCostPerLot?.Currency}}</clr-dg-cell>
            <clr-dg-cell
              [style.color]="ingredient?.replace?.quantity != ingredient?.ingredient?.UsageQuantity?.Value ? 'red' : null">
              {{ingredient?.replace?.quantity ? ingredient?.replace?.quantity + ' ' +
              (ingredient?.ingredient?.meaure?.Unit ? ingredient?.ingredient?.UsageQuantity?.Unit :
              ingredient?.replace?.product?.MeasurementUnit?.Code) : ''}}
            </clr-dg-cell>
            <clr-dg-cell
            [style.color]="ingredient?.replace?.quantity != ingredient?.ingredient?.UsageQuantity?.Value ? 'red' : null">
            {{ingredient?.replace?.quantity * ingredient?.replace?.product?.StandardCostPerLot?.Value | number : '1.2-3' }}
          </clr-dg-cell>
          </clr-dg-row>

          <clr-dg-footer>{{res.recipe.Ingredients.length}} съставки | Обща себестойност: {{totalValue[i] | number : '1.2-3'}}</clr-dg-footer>
        </clr-datagrid>
      </clr-dg-row-detail>
    </ng-container>


  </clr-dg-row>

  <!-- <clr-dg-detail *clrIfDetail="let recipie">
      <clr-dg-detail-header>{{recipie.Name}}</clr-dg-detail-header>
      <clr-dg-detail-body>
        
      </clr-dg-detail-body>
    </clr-dg-detail> -->

  <!-- <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
          <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">Технологии на страница</clr-dg-page-size>
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          от {{pagination.totalItems}} технологии
      </clr-dg-pagination>
    </clr-dg-footer> -->
</clr-datagrid>
<!-- 
<clr-tree>
    <clr-tree-node *ngFor="let res of result">
        {{res.recipe.Name}}
        <clr-tree-node *ngFor="let ingredient of res.ingredients">

            <div class="flex-table">
                <div class="flex-row">{{ingredient?.ingredient?.Material?.Name?.BG}}</div>
                <div class="flex-row">{{ingredient?.ingredient?.UsageQuantity?.Value}} {{ingredient?.ingredient?.UsageQuantity?.Unit}}</div>
                <div class="flex-row">{{replace?.productName}}</div>
                <div class="flex-row">{{replace?.quantity}} {{ingredient?.ingredient?.UsageQuantity?.Unit}}</div>

            </div>
            
        </clr-tree-node>
    </clr-tree-node>
</clr-tree>
 -->